import { render, staticRenderFns } from "./CommunityCare.vue?vue&type=template&id=4a350013&"
import script from "./CommunityCare.vue?vue&type=script&lang=js&"
export * from "./CommunityCare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports